<template>
  <CartUnpurchasableProducts
    :products="unpurchasableProducts"
    :onDelete="onDelete"
    :onMoveDetail="moveProductDetail"
  />
</template>

<script>
import Product, { ProductType } from '@/models/Product/Product'
import CartUnpurchasableProducts from '@/presentationals/v2/components/layouts/templates/CartUnpurchasableProducts'
import { Location, MoveType } from '@/plugins/AppManager'

export default {
  name: 'CartUnpurchasableProductsContainer',
  components: {
    CartUnpurchasableProducts
  },
  computed: {
    unpurchasableProducts() {
      return this.$store.getters['cart/unpurchasableProducts']
    }
  },
  methods: {
    moveProductDetail(product) {
      // 교환 반품 상품
      if (product.getReturnOrExchange()) return
      // 상품 준비중
      if (product.getDisabled()) return
      // 첫 구매 유저가 아니거나 비회원일 때
      if (product.getNotFirstPurchase() || product.getNotFirstPurchaseGuest()) return

      this.$appManager.move(Location.PRODUCT, this.$store.getters.isAndroid, MoveType.REPLACE, {
        marketProduct_ref: 'Cart',
        market_shopNo: product.getBaeminShopNo(),
        marketProduct_shopNo: product.getBaeminShopNo(),
        marketProduct_productId: product.getId()
      })
      // const url = `${this.$deepLinkProtocol}./marketProduct?marketProduct_ref=Cart&marketProduct_shopNo=${product.baeminShopNo}&marketProduct_productId=${product.productId}`
      // window.location.replace(url)
    },

    async onDelete(product, item) {
      let sendProduct = [product]
      let targetName = 'cart/removeUnpurchasableProduct'
      let params = product.getId()

      if (product.getType() <= ProductType.SINGLE) {
        targetName = 'cart/removeUnpurchasableItem'
        params = {
          productId: product.getId(),
          itemId: item.getId()
        }

        const newProduct = new Product({
          productId: product.getId(),
          items: [item]
        })

        sendProduct = [newProduct]
      }

      const result = await this.$store.dispatch('cart/removeProducts', sendProduct)

      if (!result) return
      this.$store.commit(targetName, params)
    }
  }
}
</script>